import { LanguageConfigService } from '@app/wiki/language-config.service';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { helpOptionsModel } from '@app/core/components/help-options/help-options-model';
import { System } from '@app/core/resources/system';
import { CrispService } from '@app/core/services/crisp.service';
import { OgService } from '@app/core/services/og.service';
import { PlatformBrowserService } from '@app/core/services/platform-browser.service';
import { SeoService } from '@app/core/services/seo.service';
import { SystemsService } from '@app/core/services/systems.service';
import { DocumentCollection } from 'ngx-jsonapi';

@Component({
    selector: 'app-help-center',
    templateUrl: './help-center.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./help-center.component.scss']
})
export class HelpCenterComponent implements OnInit {
    public hideHeaderAndFooter: boolean = false;
    public isHelpCenter: boolean = true;
    public helpOptionsModelCard: Array<any> = helpOptionsModel;
    public systems: Array<System> = [];
    public notRedirect: boolean = false;
    public constructor(
        public crispService: CrispService,
        private seoService: SeoService,
        private ogService: OgService,
        private activatedRoute: ActivatedRoute,
        private languageConfigService: LanguageConfigService,
        private browserService: PlatformBrowserService,
        private systemsService: SystemsService
    ) {
        this.languageConfigService
            .setActivatedRoute(this.activatedRoute)
            .updateLanguageFromUrl('help')
            .subscribe(() => {
                this.seoService.addTitle('Centro de Ayuda | Saldoar');
                this.seoService.addCanonical('ayuda');
                this.ogService.addOpenGraphMetadata({ url: 'ayuda', urlOgImage: 'assets/images/og/og-help.png' });
                this.verifyParams();
            });
    }

    private verifyParams(): void {
        this.activatedRoute.queryParams.subscribe((params: any) => {
            if (params.hide === 'true') {
                this.hideHeaderAndFooter = true;

                return;
            }
            this.hideHeaderAndFooter = false;
        });
    }
    public ngOnInit(): void {
        this.systemsService.allIncludeRates().subscribe((systems: DocumentCollection<System>): void => {
            this.systems = systems.data;
        });
    }

    public receiveEvent($event: any): void {
        this.notRedirect = $event;
    }

    public openChatWithSupport(): void {
        this.browserService.isBrowser && this.crispService.openCrispChat();
    }
}
